'use client';
import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
export const LottieAnimation = ({ url, className }: { url: string; className: string }) => {
  const [animationData, setAnimationData] = useState('');
  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(url);
        const parsed = await response.json();
        console.log(parsed, '------------');
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        setAnimationData(parsed);
      } catch (error) {
        setAnimationData('');
      }
    })();
  }, [url]);
  return animationData && Lottie ? (
    <div className={className}>
      <Lottie animationData={animationData} loop={true} />
    </div>
  ) : null;
};
